// extracted by mini-css-extract-plugin
export default {"modal":"ExternalModal_modal__Wfabq","buttons":"ExternalModal_buttons__4Rqo9"};